/**
 * Tier limit matrix — client mirror of `server/src/config/tierLimits.js`.
 * Used by editor UX (showing/hiding fields, max-photo hints) and by
 * `useTierGate`. Server is canonical for security; keep both in lockstep.
 */

export const TIER_LIMITS = {
  BASIC: {
    maxInvitations: 1,
    maxGalleryPhotos: 5,
    maxVideos: 0,
    canUploadPhotos: true,
    canUploadTimelinePhotos: false,
    canChangeSlugOnce: true,
    canChangeSlugUnlimited: false,
    canDuplicate: false,
    canQrCheckin: false,
    canLiveStream: false,
    canVideoEmbed: false,
    canBackgroundMusic: true,
    canGuestManagement: false,
    pricePerMonth: 15000
  },
  PREMIUM: {
    maxInvitations: 3,
    maxGalleryPhotos: 10,
    maxVideos: 1,
    canUploadPhotos: true,
    canUploadTimelinePhotos: true,
    canChangeSlugOnce: false,
    canChangeSlugUnlimited: true,
    canDuplicate: true,
    canQrCheckin: true,
    canLiveStream: true,
    canVideoEmbed: true,
    canBackgroundMusic: true,
    canGuestManagement: true,
    pricePerMonth: 30000
  },
  ULTIMATE: {
    maxInvitations: 10,
    maxGalleryPhotos: 20,
    maxVideos: 1,
    canUploadPhotos: true,
    canUploadTimelinePhotos: true,
    canChangeSlugOnce: false,
    canChangeSlugUnlimited: true,
    canDuplicate: true,
    canQrCheckin: true,
    canLiveStream: true,
    canVideoEmbed: true,
    canBackgroundMusic: true,
    canGuestManagement: true,
    pricePerMonth: 70000
  }
};

export const FEATURE_LABELS = {
  canDuplicate: 'Duplikat Undangan',
  canQrCheckin: 'QR Check-in',
  canLiveStream: 'Live Streaming',
  canVideoEmbed: 'Video Embed',
  canUploadTimelinePhotos: 'Foto pada Timeline',
  canGuestManagement: 'Manajemen Tamu'
};

export function getTierLimits(tier) {
  return TIER_LIMITS[tier] || TIER_LIMITS.BASIC;
}
